import React from 'react';

const SocialButton = ({ icon, label, className, url, delayClass }) => {
  const handleClick = () => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div 
      className={`social-button-container animate-fade-in-up ${delayClass}`} 
      onClick={handleClick}
    >
      <div className={`social-icon-wrapper ${className}`}>
        {icon}
      </div>
      <span className="social-label">{label}</span>
    </div>
  );
};

export default SocialButton;
